import { render } from "./SuccessStory.vue?vue&type=template&id=62e01f55"
import script from "./SuccessStory.vue?vue&type=script&lang=js"
export * from "./SuccessStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__